import { render } from "./gradientImage.vue?vue&type=template&id=a0032e24&scoped=true&ts=true"
import script from "./gradientImage.vue?vue&type=script&lang=ts"
export * from "./gradientImage.vue?vue&type=script&lang=ts"

import "./gradientImage.vue?vue&type=style&index=0&id=a0032e24&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0032e24"]])

export default __exports__